<template>
    <div :class="['dml-page-head',isWhiteTheme && 'dml-page-head--white-theme',
                  isBlackTheme && 'dml-page-head--black-theme']"
         role="banner">
        <div class="dml-page-head__start">
            <button v-on:click="menuVisibility ? closeDrawer() : openDrawer('menu')"
                    class="dml-page-head__hamburger-icon dml-page-head__btn"
                    :data-t="menuVisibility ? '14.1' : '2.4'"
                    data-tracking-attr="hamburger.click.v2"
                    data-ga="m_menu.click_menu"
                    :data-ga-label="menuVisibility ? 'Zamknięcie menu' : 'Otwarcie menu'">
                <span :class="['dml-page-head__hamburger dml-page-head__hamburger-roll',
                               isWhiteTheme && 'dml-page-head__hamburger--white-theme dml-page-head__hamburger-roll--white-theme']">
                </span>
            </button>
            <svg width="256"
                 height="54"
                 viewBox="0 0 553 72"
                 fill="none"
                 :class="['dml-page-head__logo-behind', isBlackTheme && 'dml-page-head__logo-behind--black-theme', isWhiteTheme && 'dml-page-head__logo-behind--white-theme']">
                <path d="M85.356-4.736h-21.71v36.3c-5.794-3.951-12.764-5.99-20.88-5.99C19.728 25.083-.488 44.333.009 66.267c-.497 21.935 19.719 41.183 42.757 40.709h.06c7.226.129 12.326-2.442 18.18-4.898 5.642-2.37 12.43-3.448 14.453 2.312l.467 1.336h9.43V-4.736zM42.6 86.939c-12.1 0-21.047-8.835-21.047-20.671 0-11.836 8.947-20.67 21.046-20.67 12.1 0 21.379 8.834 21.379 20.67 0 11.836-9.279 20.67-21.379 20.67zM182.499 66.268c.498 21.935-19.718 41.183-42.756 40.709-23.038.474-43.254-18.774-42.756-40.709-.498-21.935 19.718-41.183 42.756-40.71 23.038-.473 43.254 18.775 42.756 40.71zm-63.968 0c0 11.836 9.278 20.67 21.378 20.67s21.046-8.834 21.046-20.67c0-11.836-8.946-20.67-21.046-20.67s-21.378 8.834-21.378 20.67zM417.687 66.268c.498 21.935-19.718 41.183-42.756 40.709-23.038.474-43.254-18.774-42.756-40.709-.498-21.935 19.718-41.183 42.756-40.71 23.038-.473 43.254 18.775 42.756 40.71zm-63.968 0c0 11.836 9.278 20.67 21.378 20.67s21.046-8.834 21.046-20.67c0-11.836-8.946-20.67-21.046-20.67s-21.378 8.834-21.378 20.67zM527.308 6.152C527.308-.628 532.95-6 540.237-6 547.358-6 553-.628 553 6.152c0 6.939-5.642 12.31-12.763 12.31-7.287 0-12.929-5.371-12.929-12.31zm2.157 20.743h21.544v78.832h-21.544V26.895zM511.662-4.736h-21.71v36.3c-5.793-3.951-12.763-5.99-20.88-5.99-23.037-.475-43.254 18.774-42.756 40.708-.498 21.935 19.719 41.183 42.756 40.709h.06c7.227.13 12.326-2.442 18.18-4.898 5.643-2.37 12.432-3.447 14.453 2.313l.468 1.336h9.429V-4.736zm-42.771 91.675c-12.1 0-21.046-8.835-21.046-20.671 0-11.836 8.946-20.67 21.046-20.67s21.378 8.834 21.378 20.67c.015 11.836-9.278 20.67-21.378 20.67zM284.168 25.53c-11.812 0-17.576 6.536-26.22 6.536-8.645 0-12.688-6.536-26.221-6.536-8.509 0-15.238 3.807-19.749 5.487-3.802 1.423-7.8.675-9.158-3.217l-.407-1.164h-8.267v79.077h22.026v-44.76c0-10.127 5.009-16.275 15.57-16.275 9.927 0 15.569 6.148 15.569 16.275v44.76h21.303v-44.76c0-10.127 6.97-16.275 15.57-16.275 10.304 0 15.569 6.148 15.569 16.275v44.76h21.303V62.131c-.015-23.472-15.826-36.6-36.888-36.6z" fill-opacity=".4" />
            </svg>
            <a :class="['dml-page-head__logo', isWhiteTheme && 'dml-page-head__logo--white-theme']" href="/" data-t="16.2">
                <svg width="98" height="20" viewBox="0 0 98 20" xmlns="http://www.w3.org/2000/svg">
                    <title>Domodi</title>
                    <path fill="currentColor" d="M15.126.224H11.28v6.424c-1.027-.699-2.262-1.06-3.7-1.06-4.083-.086-7.666 3.32-7.577 7.203-.089 3.882 3.494 7.289 7.577 7.205h.01c1.281.023 2.185-.432 3.222-.867 1-.42 2.203-.61 2.561.41l.083.236h1.671V.224zM7.55 16.449c-2.144 0-3.73-1.563-3.73-3.658 0-2.095 1.586-3.659 3.73-3.659s3.789 1.564 3.789 3.659c0 2.095-1.645 3.658-3.789 3.658zM32.342 12.79c.088 3.883-3.495 7.29-7.577 7.206-4.083.084-7.666-3.323-7.577-7.205-.089-3.882 3.494-7.29 7.577-7.205 4.082-.084 7.665 3.323 7.577 7.205zm-11.336 0c0 2.096 1.644 3.66 3.788 3.66s3.73-1.564 3.73-3.66c0-2.094-1.586-3.658-3.73-3.658s-3.788 1.564-3.788 3.659zM74.02 12.79c.089 3.883-3.494 7.29-7.577 7.206-4.082.084-7.665-3.323-7.577-7.205-.088-3.882 3.495-7.29 7.577-7.205 4.083-.084 7.666 3.323 7.577 7.205zm-11.336 0c0 2.096 1.645 3.66 3.789 3.66s3.73-1.564 3.73-3.66c0-2.094-1.586-3.658-3.73-3.658s-3.789 1.564-3.789 3.659zM93.447 2.15c0-1.2 1-2.15 2.291-2.15C97 0 98 .95 98 2.15c0 1.229-1 2.18-2.262 2.18-1.291 0-2.291-.951-2.291-2.18zm.382 3.672h3.818v13.953h-3.818V5.822zM90.674.224h-3.847v6.424c-1.026-.699-2.262-1.06-3.7-1.06-4.083-.084-7.665 3.323-7.577 7.205-.088 3.883 3.494 7.29 7.577 7.205h.01c1.281.023 2.185-.432 3.222-.867 1-.419 2.203-.61 2.562.41l.082.236h1.671V.224zm-7.58 16.225c-2.143 0-3.729-1.563-3.729-3.658 0-2.095 1.586-3.659 3.73-3.659s3.788 1.564 3.788 3.659c.003 2.095-1.644 3.658-3.788 3.658zM50.36 5.58c-2.094 0-3.116 1.157-4.648 1.157-1.532 0-2.248-1.156-4.646-1.156-1.508 0-2.7.673-3.5.97-.674.252-1.382.12-1.623-.569l-.072-.206h-1.465v13.996h3.903V11.85c0-1.792.888-2.88 2.76-2.88 1.759 0 2.759 1.088 2.759 2.88v7.922h3.775V11.85c0-1.792 1.235-2.88 2.759-2.88 1.826 0 2.759 1.088 2.759 2.88v7.922h3.775V12.06c-.002-4.155-2.804-6.478-6.537-6.478z" />
                </svg>
            </a>
        </div>
        <div class="dml-page-head__end">
            <button v-on:click="openDrawer('search')"
                    data-t="5.6"
                    :class="['dml-page-head__search', isWhiteTheme && 'dml-page-head__search--white-theme']"
                    data-action="search"
                    data-ga="m_search.open">
                <span>{{searchText}}</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10ZM14.8974 16.3262C13.5441 17.3754 11.845 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8444 17.3758 13.5431 16.3272 14.8962L20.5 19.0711C20.8951 19.4657 20.8951 20.1054 20.5 20.5C20.1049 20.8946 19.4643 20.8946 19.0691 20.5L14.8974 16.3262Z" />
                </svg>
            </button>
            <a href="/moje-ulubione-produkty"
               data-t="1.2"
               :class="['dml-page-head__btn js-like-counter like-counter',
                        isBlackTheme && 'like-counter--black-theme',
                        isWhiteTheme && 'dml-page-head__btn--white-theme like-counter--white-theme']"
               data-like-counter="0"
               data-ga="mega_menu.click_favourites"
               data-ga-label="ikona">
                <svg width="24" height="24" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.30064 3.84063C8.09742 1.9749 6.195 1.4642 4.63491 1.8911C3.12038 2.30553 1.75 3.65725 1.75 6.10073C1.75 7.16394 1.9495 8.05231 2.58716 9.10225C3.26989 10.2264 4.49081 11.5932 6.68423 13.4898L11 17.1494L15.3157 13.4899C17.5092 11.5932 18.7301 10.2265 19.4128 9.10228C20.0505 8.05234 20.25 7.16397 20.25 6.10079C20.25 3.65728 18.8796 2.30558 17.3651 1.89115C15.805 1.46425 13.9026 1.97496 12.6993 3.84065C12.3271 4.41792 11.6853 4.76356 11 4.76356C10.3147 4.76355 9.67293 4.41791 9.30064 3.84063ZM4.239 0.444288C6.41289 -0.150574 8.99353 0.596762 10.5612 3.02767C10.6544 3.17219 10.819 3.26355 11 3.26356C11.181 3.26356 11.3456 3.17219 11.4388 3.02767C13.0065 0.596818 15.5871 -0.150519 17.761 0.444341C19.9243 1.0363 21.75 2.97799 21.75 6.10079C21.75 7.41204 21.4883 8.57459 20.6949 9.88092C19.8908 11.2049 18.5304 12.6934 16.2941 14.6269L16.2887 14.6316L11.7602 18.4714C11.3221 18.8429 10.6779 18.8429 10.2398 18.4714L5.70584 14.6269C3.46958 12.6934 2.10916 11.2048 1.30508 9.88089C0.511709 8.57456 0.25 7.41202 0.25 6.10073C0.25 2.97795 2.07572 1.03625 4.239 0.444288Z" />
                </svg>
            </a>
        </div>
        <template v-if="routerEnabled">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </template>
        <dm-page-preloader :isLoading="showLoader"></dm-page-preloader>
    </div>
</template>

<script>
    import DM from 'DM';
    import debounce from "~/utils/debounce.js";
    import Hub from '../../hub.js';
    import * as types from '../../store/types.js';
    import PagePreloader from '../shared/page-preloader-component.vue';
    import { SIZES } from '../../utils/screen-sizes';

    const SEARCH_TEXT = {
        short: 'Szukaj',
        long: 'Szukaj wśród milionów produktów i tysięcy okazji'
    }

    export default {
        name: 'dm-page-header',
        components: {
            'dm-page-preloader': PagePreloader
        },
        data: () => ({
            routerEnabled: false,
            hamburgerItem: null,
            hamburgerItemMenu: null,
            searchText: SEARCH_TEXT.short
        }),
        computed: {
            showLoader() {
                return this.$store.state.menu.menuDrawer.redirecting;
            },
            menuVisibility() {
                return this.$store.state.menu.menuDrawer.visible;
            },
            isBlackTheme() {
                return DM.Config.headerColor === '_black';
            },
            isWhiteTheme() {
                return DM.Config.headerColor === '_white';
            }
        },
        mounted() {
            this.$store.dispatch(types.USER_FETCH_DATA);
            this.hamburgerItem = document.querySelector('.dml-page-head__hamburger-icon');

            this.debounceResize = debounce(this.handleResize.bind(this), 200);
            window.addEventListener('resize', this.debounceResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.debounceResize);
        },
        methods: {
            openDrawer(name) {
                if (!this.routerEnabled) {
                    Hub.publish(Hub.INIT_PAGE_HEAD_ROUTER);
                    this.routerEnabled = true;
                }
                this.$router.push({ name });
            },
            closeDrawer() {
                this.$router.go(-1);
            },
            handleResize() {
                this.searchText = window.innerWidth > SIZES.MEDIUM ? SEARCH_TEXT.long : SEARCH_TEXT.short;
            },
        },
        watch: {
            menuVisibility(val) {
                if (val) {
                    if (!this.hamburgerItemMenu) {
                        this.hamburgerItemMenu = document.querySelector('.dml-page-head__hamburger-icon');
                    }
                    if (this.hamburgerItem && this.hamburgerItemMenu) {
                        this.hamburgerItem.classList.add('dml-page-head__hamburger--is-active');
                        setTimeout(() => {
                            this.hamburgerItemMenu.classList.add('dml-page-head__hamburger--is-active');
                        }, 50);
                    }
                } else if (this.hamburgerItem && this.hamburgerItemMenu) {
                    this.hamburgerItemMenu.classList.remove('dml-page-head__hamburger--is-active');
                    setTimeout(() => {
                        this.hamburgerItem.classList.remove('dml-page-head__hamburger--is-active');
                    }, 50);
                }
            }
        }
    };
</script>
